<template>
  <div>
    <nav
      @focusout="isActive = false"
      tabindex="-1"
      class="navbar is-dark is-fixed-top is-vcentered"
      :class="isCentered ? ' display-center' : ''"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="navbar-brand" :class="isBreadCumb ? '' : ' center-logo'">
        <RouterLink class="navbar-item menu-golstats" :to="{ path: '/' }">
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/logo_golstats_horizontal_white.svg" alt="GolStats Logo" />
        </RouterLink>
        <a class="navbar-item is-hidden">
          <BIcon icon="magnify" type="is-light" size="is-normal"> </BIcon>
        </a>
        <a class="navbar-item push-right is-hidden-desktop" @click="doLogout">
          <BIcon icon="power-standby" type="is-primary" size="is-normal"> </BIcon>
        </a>
        <a
          v-if="showMenuItems"
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="current-items"
          @click="isActive = !isActive"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div v-if="showMenuItems" id="current-items" class="navbar-menu" :class="isActive ? ' is-active' : ''">
        <div class="navbar-end">
          <a class="navbar-item" @click="onClickTeamAnalysis">
            {{ $t('general.team_analysis') }}
          </a>
          <a class="navbar-item" @click="onClickPlayerAnalysis">
            {{ $t('general.player_analysis') }}
          </a>
          <a v-if="isNextGamesAllowed" class="navbar-item" @click="onClickNextMatches">
            PROXIMOS PARTIDOS
          </a>
        </div>
      </div>
      <div class="navbar-end is-hidden-touch">
        <a class="navbar-item" :class="isCentered ? ' push-right' : ''" @click="doLogout">
          <BIcon icon="power-standby" type="is-primary" size="is-normal"> </BIcon>
        </a>
      </div>
    </nav>
  </div>
</template>

<script>
import {
  menuAnalizarEquipos,
  menuAnalizarJugadores,
  menuProximosPartidos,
  finalizarSesion,
} from '@/utils/analytics/general';
import { mapGetters } from 'vuex';

export default {
  props: {
    showMenuItems: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  computed: {
    ...mapGetters('loginGeneral', ['isNextGamesAllowed']),
    isBreadCumb() {
      return this.$store.state.windowWidth < 1024 ? true : false;
    },
    isCentered() {
      return this.$route.name === 'gs' ? true : false;
    },
  },
  methods: {
    goTo(route) {
      this.$router.push(route);
      this.isActive = false;
    },
    logout() {
      this.$store.commit('mediaGeneral/setUserPlaylists', []);
      this.$store.commit('teamsGeneral/updateTeams', []);
      this.$store.dispatch('loginGeneral/deleteUserInfo');
      // console.log('llego aqui 3');
      this.$router.push('/');
    },
    doLogout() {
      this.$buefy.dialog.confirm({
        title: this.$t('log_in_out.log_out'),
        message: this.$t('log_in_out.log_out_confirm'),
        confirmText: this.$t('log_in_out.exit'),
        cancelText: this.$t('general.cancel'),
        type: 'is-primary',
        onConfirm: () => {
          finalizarSesion();
          this.logout();
        },
      });
    },

    onClickTeamAnalysis() {
      menuAnalizarEquipos();
      this.goTo('/teamsAnalysis/teams');
    },
    onClickPlayerAnalysis() {
      menuAnalizarJugadores();
      this.goTo('/playersAnalysis/teams');
    },
    onClickNextMatches() {
      menuProximosPartidos();
      this.goTo('/nextGamesAnalysis/games');
    },
  },
};
</script>

<style scoped>
.navbar-item {
  text-transform: uppercase;
}
.center-logo {
  position: absolute;
}
.display-center {
  justify-content: center;
}
nav.navbar {
  align-items: center;
}
.navbar-burger.burger {
  margin-left: 0px;
}
.navbar-item.push-right {
  margin-left: auto;
}
@media screen and (min-width: 1024px) {
  .navbar {
    min-height: 4.5rem;
  }
  .navbar-item img {
    min-height: 2.5rem;
  }
}
</style>
<style>
.dialog.modal.is-active .modal-card-foot button {
  text-transform: capitalize;
}
</style>
